export const subscriptionId = (state) => state.auth.subscriptionId || [];
export const total = (state) => state.payment.total || 0;
